import { CUSTOM_CONFIG_STORAGE_KEY, customizeConfig } from "PFCore/initializers/customize_config";

const TRAILING_SLASH = /\/$/;

export const applyUrlConfig = (): boolean => {
  const currentUrl = new URL(window.location.href);
  const { searchParams } = currentUrl;

  const apiEndpoint = searchParams.get("api_endpoint")?.replace(TRAILING_SLASH, "");
  const developmentDomain = searchParams.get("development_domain");
  const atlasEndpoint = searchParams.get("atlas_endpoint")?.replace(TRAILING_SLASH, "");

  if (!apiEndpoint || !developmentDomain) {
    return false;
  }

  const {
    api_endpoint: currentApiEndpoint,
    development_domain: currentDevelopmentDomain,
    atlas_endpoint: currentAtlasEndpoint
  } = window.PF.config;

  const isAtlasEndpointUnchanged = atlasEndpoint
    ? atlasEndpoint === currentAtlasEndpoint
    : !window.storage.getItem(CUSTOM_CONFIG_STORAGE_KEY)?.atlas_endpoint;

  if (
    apiEndpoint === currentApiEndpoint &&
    developmentDomain === currentDevelopmentDomain &&
    isAtlasEndpointUnchanged
  ) {
    return false;
  }

  customizeConfig({
    api_endpoint: apiEndpoint,
    development_domain: developmentDomain,
    ...(atlasEndpoint ? { atlas_endpoint: atlasEndpoint } : {})
  });

  searchParams.delete("api_endpoint");
  searchParams.delete("development_domain");
  searchParams.delete("atlas_endpoint");

  window.location.replace(currentUrl.toString());

  return true;
};
